class CheckoutLocker extends HTMLElement {
  constructor() {
    super();
    this.minimum = Number(this.dataset.minimum || 0);
  }

  connectedCallback() {
    this.button = this.querySelector("button");
    this.message = this.querySelector(".cart-minimum-message");

    const target = document.querySelector(".totals__subtotal-value");

    if (target) {
      this.updateState(this.parsePrice(target.textContent));
      const observer = new MutationObserver(() => {
        this.updateState(this.parsePrice(target.textContent));
      });

      observer.observe(target, {
        characterData: true,
        childList: true,
        subtree: true,
      });
    }
  }

  parsePrice(text) {
    let number = text.replace(/[^0-9,\.\-]/g, "").replace(/\s/g, "");
    const lastComma = number.lastIndexOf(",");
    const lastDot = number.lastIndexOf(".");

    if (lastComma > lastDot) {
      number = number.replace(/\./g, "").replace(",", ".");
    } else {
      number = number.replace(/,/g, "");
    }

    return parseFloat(number) || 0;
  }

  updateState(total) {
    this.button.disabled = total < this.minimum;
    this.message.hidden = total >= this.minimum;
  }
}

if (!customElements.get("checkout-locker")) {
  customElements.define("checkout-locker", CheckoutLocker);
}
